import Skeleton from "react-loading-skeleton";
import React from "react";
import {Carousel} from "react-bootstrap";
import {useScreenSizeDetector} from "../hooks/useScreenSizeDetector";

export const SkeletonGallery = () => {
    const {isSmallScreenSize} = useScreenSizeDetector();

    return (
        <>
            <Carousel
                id="product-gallery"
                className="d-flex align-items-center"
                indicators={false}
                interval={null}
                touch={false}
                draggable={false}
                variant="dark"
                controls={false}
                wrap={false}
            >
                <Carousel.Item>
                    <div className="image-container">
                        <Skeleton height={isSmallScreenSize ? 250 : 400} width={600}/>
                    </div>
                </Carousel.Item>
            </Carousel>
            {isSmallScreenSize ?
                <ul className="custom-carousel-indicators carousel-indicators d-flex flex-wrap m-0 mt-2"
                    style={{listStyle: 'none'}}>
                    <li>
                        <Skeleton height={12} width={12} className="rounded-circle mx-1"/>
                    </li>
                    <li>
                        <Skeleton height={12} width={12} className="rounded-circle mx-1"/>
                    </li>
                    <li>
                        <Skeleton height={12} width={12} className="rounded-circle mx-1"/>
                    </li>
                    <li>
                        <Skeleton height={12} width={12} className="rounded-circle mx-1"/>
                    </li>
                </ul>
                :
                <div className="flex-wrap d-flex mt-2" style={{minHeight: '136px'}}>
                    <Thumbnail/>
                    <Thumbnail/>
                    <Thumbnail/>
                    <Thumbnail/>
                    <Thumbnail/>
                </div>
            }
        </>
    )
};

const Thumbnail = () => {
    return (
        <div className='position-relative text-center overlay-thumb-wrap mx-1'>
            <div style={{width: '60px', height: '60px'}}>
                <Skeleton height={50} width={50}/>
            </div>
        </div>
    );
}